import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { Alert } from "@akj-dev/shared-components";

interface LabelSIMWarningProps {
  handleYes: () => void;
  handleNo: () => void;
  show: boolean;
}

export const LabelSIMWarning = ({
  handleYes,
  handleNo,
  show,
}: LabelSIMWarningProps) => (
  <Dialog open={show}>
    <DialogTitle>Are you sure?</DialogTitle>
    <DialogContent>
      <Alert
        type="warning"
        message={
          <div>
            Please note - whilst FOC to customer, there is an associated cost
            per SIM label to Daisy. <b>Are you sure you wish to continue?</b>
          </div>
        }
      />
    </DialogContent>
    <DialogActions>
      <Button onClick={handleNo}>No</Button>
      <Button variant="contained" color="primary" onClick={handleYes}>
        Yes
      </Button>
    </DialogActions>
  </Dialog>
);
